import * as angular from "angular";

angular
  .module('bringoz.admin.lean-planning')
  .constant('LeanPlanning_PN', {
    database: 'LeanPlanning_PN',
    isBranchEntity: false
  });
